import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getPageLinkByNodeId } from "@insite/client-framework/Store/Links/LinksSelectors";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import LazyImage from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

export interface InfoLinkFieldValue {
    type: "InfoLink";
    value: string;
}

interface InfoCardModel {
    fields: {
        image: string;
        title: string;
        description: string;
        link: InfoLinkFieldValue;
        linkTitle: string;
    };
}

const enum fields {
    infoCards = "infoCards",
    image = "image",
    title = "title",
    description = "description",
    link = "link",
    linkTitle = "linkTitle",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.infoCards]: InfoCardModel[];
    };
}
export interface MappedLink {
    title?: string;
    url?: string;
    image?: string;
    description?: string;
    link?: InfoLinkFieldValue;
    linkTitle?: string;
}

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => {
    const {
        fields: { infoCards },
    } = ownProps;
    const mappedInfoCards = [];
    for (const card of infoCards) {
        let mappedLink: MappedLink | undefined;
        // let readonlyPageLink : string[] | undefined;
        const readonlyPageLink = getPageLinkByNodeId(state, card.fields.link.value) || undefined;
        // const readonlyPageLink = getPageLinkByNodeId(state, card.fields.link.value);
        const linkData = readonlyPageLink || undefined;
        if (linkData) {
            mappedLink = { ...card.fields };
            mappedLink.url = linkData.url;
        }
        mappedInfoCards.push(mappedLink);
    }
    return {
        mappedInfoCards,
    };
};
type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface IInfoCardsStyles {
    container?: GridContainerProps;
    infoCard?: GridItemProps;
    customflyImgWrapper?: InjectableCss;
    customDescriptionText?: TypographyPresentationProps;
    customFlyTitle?: TypographyPresentationProps;
    infocardcontainer?: InjectableCss;
    infocardWraper?: InjectableCss;
    buttonStyle?: LinkPresentationProps;
}

export const infoCardsStyles: IInfoCardsStyles = {
    infocardcontainer: {
        css: css`
            padding: 30px 0px;
            max-width: 1140px;
            margin: 0 auto;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            max-width: 100% !important;
                            padding: 27px 0px;
                        `,
                        css`
                            max-width: 100% !important;
                            padding: 27px 0px;
                        `,
                        css`
                            max-width: 720px !important;
                            padding: 30px 0px;
                        `,
                        css`
                            max-width: 960px !important;
                            padding: 30px 0px;
                        `,
                        css`
                            max-width: 1140px !important;
                            padding: 30px 0px;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    container: {
        gap: 38,
        css: css`
            align-items: center;
            margin: 0 auto;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            max-width: 100% !important;
                            padding: 0 30px;
                        `,
                        css`
                            max-width: 100% !important;
                            padding: 0 30px;
                        `,
                        css`
                            max-width: 720px !important;
                            padding: 0 0px;
                        `,
                        css`
                            max-width: 960px !important;
                            padding: 0 0px;
                        `,
                        css`
                            max-width: 1140px !important;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    infoCard: {
        width: [12, 12, 4, 4, 4],
        css: css`
            // margin-right: 38px !important;
            // :nth-child(3n) {
            //     margin-right: 0px !important;
            // }
            /* :only-child {
                margin-right: 0px;
                //width: 230px;
                img {
                    height: 200px;
                    width: 100%;
                    object-fit: cover;
                }
            } */
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 15px;
                        `,
                        css`
                            padding: 15px;
                        `,
                        css`
                            padding: 19px;
                        `,
                        css`
                            padding: 19px;
                        `,
                        css`
                            padding: 19px;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    infocardWraper: {
        css: css`
            border: 1px solid #e5e5e5;
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
        `,
    },
    customflyImgWrapper: {
        css: css`
            box-sizing: border-box;
            width: 100%;
            div[class^="LazyImageStyle"] {
                width: 100%;
                height: auto;
            }
            img {
                height: 200px;
                width: 100%;
                object-fit: cover;
            }
        `,
    },
    customFlyTitle: {
        variant: "p",
        css: css`
            color: #33333a;
            font-size: 21px;
            font-weight: 600;
            letter-spacing: 0;
            line-height: 25px;
            margin-bottom: 10px;
            padding-left: 20px;
            padding-right: 20px;
            margin-top: 7px;
        `,
    },
    customDescriptionText: {
        variant: "p",
        css: css`
            color: #33333a;
            font-size: 16px;
            font-weight: 300;
            letter-spacing: 0;
            line-height: 24px;
            margin-bottom: 17px;
            padding-left: 20px;
            padding-right: 20px;
        `,
    },
    buttonStyle: {
        css: css`
            margin-bottom: 24px;
            span {
                background-color: #33333a !important;
                align-items: "center";
                color: #ffffff !important;
                font-family: "proxima-nova";
                font-size: 12px;
                font-weight: bold;
                letter-spacing: 2px;
                line-height: normal;
                text-align: center;
                text-transform: uppercase;
                padding: 10px 20px;
                &:hover {
                    background-color: #000 !important;
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                width: 100%;
                            `,
                            css`
                                width: 100%;
                            `,
                            css`
                                width: auto;
                            `,
                            css`
                                width: 180px;
                            `,
                            css`
                                width: 180px;
                            `,
                        ],
                        "min",
                    )}
            }
        `,
    },
};

const styles = infoCardsStyles;

const INTInfoCards: React.FC<Props> = ({ fields, mappedInfoCards }) => {
    return (
        <StyledWrapper {...styles.infocardcontainer}>
            {mappedInfoCards?.length > 0 ? (
                <GridContainer {...styles.container}>
                    {mappedInfoCards?.map((card, index) => {
                        return (
                            <GridItem
                                id="each-column"
                                // eslint-disable-next-line react/no-array-index-key
                                key={index}
                                {...styles.infoCard}
                            >
                                <StyledWrapper {...styles.infocardWraper}>
                                    {card && card?.image && (
                                        <StyledWrapper {...styles.customflyImgWrapper}>
                                            <LazyImage src={card?.image} altText={card?.title} />
                                        </StyledWrapper>
                                    )}
                                    {card && card?.title && (
                                        <Typography {...styles.customFlyTitle}>{card?.title}</Typography>
                                    )}
                                    {card && card?.description && (
                                        <Typography {...styles.customDescriptionText}>{card?.description}</Typography>
                                    )}
                                    {card && card?.url && (
                                        <StyledWrapper
                                            css={css`
                                                padding: 0 20px;
                                                margin-top: auto;
                                            `}
                                        >
                                            <Link {...styles.buttonStyle} href={card?.url}>
                                                {card?.linkTitle}
                                            </Link>
                                        </StyledWrapper>
                                    )}
                                </StyledWrapper>
                            </GridItem>
                        );
                    })}
                </GridContainer>
            ) : null}
        </StyledWrapper>
    );
};

const membersList: WidgetModule = {
    component: connect(mapStateToProps)(INTInfoCards),
    definition: {
        group: "Common",
        fieldDefinitions: [
            {
                name: fields.infoCards,
                editorTemplate: "ListField",
                getDisplay: (item: HasFields) => {
                    return item.fields.title;
                },
                defaultValue: [],
                fieldType: "Translatable",
                sortOrder: 1,
                fieldDefinitions: [
                    {
                        name: fields.title,
                        displayName: "Title",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        sortOrder: 0,
                    },
                    {
                        name: fields.image,
                        displayName: "Photo",
                        editorTemplate: "ImagePickerField",
                        defaultValue: "",
                        sortOrder: 1,
                    },
                    {
                        name: fields.description,
                        displayName: "Description",
                        editorTemplate: "MultilineTextField",
                        defaultValue: "",
                        sortOrder: 6,
                    },
                    {
                        name: fields.link,
                        displayName: "Link",
                        editorTemplate: "LinkField",
                        defaultValue: { type: "Page", value: "" },
                        // allowUrls: item => false,
                        // allowCategories: item => false,
                        sortOrder: 4,
                    },

                    {
                        name: fields.linkTitle,
                        displayName: "Link Title",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        sortOrder: 5,
                    },
                ],
            },
        ],
    },
};

export default membersList;
